import React, { useEffect, useState } from 'react';
import { MinimizedCard } from './MinimizedCard';
import { useSelector } from 'react-redux';
import { ArrowDownIcon } from '../icons';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const MinimizedCardDockMobile = () => {
    const { minimizedCards } = useSelector(state => state.minimized_card);
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const isWorkspacePage = location.pathname.includes('/workspaces/');

    const hasMinimizedCards = minimizedCards && minimizedCards.length > 0;

    const renderFirstMinimizedCard = () => {
        if (!hasMinimizedCards) {
            return null;
        }

        const firstCard = minimizedCards[minimizedCards.length - 1];
        const toggleable = minimizedCards.length > 1;

        return (
            <MinimizedCard
                key={firstCard.id}
                card={firstCard.content_group}
                toggle={toggleable}
                workspace={firstCard.workspace}
                mobile
                setCollapsed={setCollapsed}
            />
        );
    };

    const renderMinimizedCards = () => {
        if (!hasMinimizedCards) {
            return null;
        }

        if(minimizedCards.length === 1) {
            return renderFirstMinimizedCard({toggle: false});
        }
        

        return minimizedCards.map(data => (
            <MinimizedCard key={data.id} card={data.content_group} workspace={data.workspace} mobile/>
        ));
    };

    const renderToggleDockButton = () => {
        if (!collapsed) return null;
        if(minimizedCards.length < 1) return null;
        
        return (
            <div
                className="minimize-card-dock-mobile-toggle-container px-2 d-flex justify-content-end align-items-center cursor-pointer"
            >
                <div onClick={() => setCollapsed(prev => !prev)}>
                    <ArrowDownIcon />
                </div>
            </div>
        );
    };

    useEffect(() => {
        if(minimizedCards.length === 1){
            setCollapsed(false)
        }
    },  [minimizedCards]);

    return (
        <div className={`minimize-card-dock-mobile-container d-lg-none rounded ${isWorkspacePage ? '' : 'no-bottom'}`}>
            <div className="minimize-card-dock-mobile-body bg-white rounded">
                {renderToggleDockButton()}
                <div className="minimized-card-dock-mobile w-100">
                    <div style={{ display: collapsed ? 'block' : 'none' }}>
                        {renderMinimizedCards()}
                    </div>
                    <div style={{ display: collapsed ? 'none' : 'block' }}>
                        {renderFirstMinimizedCard()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export { MinimizedCardDockMobile };